<template>
  <section
    class="repair-calculator"
    role="dialog"
    aria-modal="true"
    aria-labelledby="repair-calculator-title"
  >
    <header class="repair-calculator__header">
      <span class="repair-calculator__icon">
        <Calculator :size="24" />
      </span>

      <div>
        <h2 id="repair-calculator-title">Калькулятор ремонта</h2>
        <p>Предварительная оценка стоимости ремонта</p>
      </div>
    </header>

    <div class="repair-calculator__fields">
      <label>
        <span>Стоимость запчасти, ₽</span>
        <input
          ref="price"
          v-model="sparePartPrice"
          type="number"
          min="0"
          step="any"
          required
        >
      </label>

      <label>
        <span>Доставка, ₽</span>
        <input
          v-model="deliveryPrice"
          type="number"
          min="0"
          step="any"
          required
        >
      </label>
    </div>

    <p
      v-if="!isValid"
      class="repair-calculator__error"
      role="alert"
    >
      Укажите стоимость запчасти и доставки: числа от нуля.
    </p>

    <div
      class="repair-calculator__result"
      aria-live="polite"
      aria-atomic="true"
    >
      <span>Рекомендуемая стоимость</span>
      <strong>{{ getResultPrice }}</strong>
      <small
        v-if="isValid"
      >
        Запчасть × {{ coefficient }} + доставка
      </small>
      <small>Минимальная стоимость ремонта — 3 500 ₽</small>
    </div>

    <footer class="repair-calculator__actions">
      <button
        type="button"
        @click="reset"
      >
        Сбросить
      </button>

      <button
        type="button"
        class="repair-calculator__close"
        @click="closeModal('repair-calculator')"
      >
        Закрыть
      </button>
    </footer>
  </section>
</template>

<script>
import { mapActions } from 'vuex'

import { Calculator } from 'lucide-vue'
import { priceToFormat } from '@/helper'

const COEFFICIENTS = [
  { limit: 1500, value: 3 },
  { limit: 2500, value: 2.8 },
  { limit: 4500, value: 2 },
  { limit: 7500, value: 1.8 },
  { limit: 12500, value: 1.7 },
  { limit: 22500, value: 1.6 },
  { limit: 35500, value: 1.5 }
]

export default {
  name: 'RepairCalculator',
  components: { Calculator },
  data () {
    return {
      sparePartPrice: 0,
      deliveryPrice: 500
    }
  },
  computed: {
    isValid () {
      return [this.sparePartPrice, this.deliveryPrice].every(value => {
        return String(value).trim() !== '' && Number.isFinite(Number(value)) && Number(value) >= 0
      }) && Number.isFinite(this.result)
    },
    coefficient () {
      return COEFFICIENTS.find(({ limit }) => Number(this.sparePartPrice) <= limit)?.value || 1
    },
    result () {
      return Math.max(3500, Number(this.sparePartPrice) * this.coefficient + Number(this.deliveryPrice))
    },
    getResultPrice () {
      return this.isValid ? priceToFormat(this.result) : '—'
    }
  },
  methods: {
    ...mapActions('modal', ['closeModal']),
    priceToFormat,
    reset () {
      this.sparePartPrice = 0
      this.deliveryPrice = 500
      this.$refs.price.focus()
    }
  }
}
</script>

<style scoped lang="scss" src="./style.scss" />
